import { getFormatMessage } from "@/utils/utils";
import { TemplateReferenceItem } from "../interface";

export function getRefTypeDesc(refs: TemplateReferenceItem[]) {
  const formatMessage = getFormatMessage()
  return refs
    ?.map(
      (x) =>
        `【${formatMessage({
          id: 'app.template.reference.objectType.' + x.objectType
        })}】`
    )
    .join('、')
}
